<div id="imageViewer" class="image_viewer-container display-none">
    <span class="image_viewer-close_button delete-button delete-button__light" (click)="closeViewer()">&times;</span>
    <img class="image_viewer_image" #imageElement src="assets/images/home/home_1.jpeg" alt="image">
</div>
